import { render } from "./GithubDownloadModal.vue?vue&type=template&id=25b4207d&scoped=true"
import script from "./GithubDownloadModal.vue?vue&type=script&lang=js"
export * from "./GithubDownloadModal.vue?vue&type=script&lang=js"

import "./GithubDownloadModal.vue?vue&type=style&index=0&id=25b4207d&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b4207d"]])

export default __exports__